import { ajaxSuccess, iconMimeType, bytesToHuman } from './helpers';

$(document).on('click', '.question-update-lock', function(e) {
    const { lock, href } = this.dataset;
    const self = this;
    axios({
        method: 'POST',
        url: href,
        data: {
            lock: lock
        }
    })
    .then((res) => {
        ajaxSuccess(res);
        const { data: { locked } } = res.data;
        self.dataset.lock = locked ? 0 : 1;
        const _tpl = self.querySelector(`template[data-${locked ? 'unlock' : 'lock'}]`).content.cloneNode(true)
        self.querySelector('.inner-content').innerHTML = _tpl.children[0].innerHTML
    })
})

$(document).on('click', '.question-container .btn-container .btn-question-edit', function(e) {
    e.preventDefault()
    const sefl = this;
    const _titleTpl = document.querySelector('template#edit-question-title-template').content.cloneNode(true)
    const _descTpl  = document.querySelector('template#edit-question-description-template').content.cloneNode(true)

    const $container        = $('.question-container')
    const $titleContainer   = $container.find('.form-header')
    const $descContainer    = $container.find('.form-body .form-description')

    const _oldTitle = $titleContainer.find('.title').text().trim()
    const _oldDesc  = $descContainer.find('.form-content').text().trim()

    _titleTpl.querySelector('input[name="question"]').value = _oldTitle
    _descTpl.querySelector('textarea[name="description"]').value = _oldDesc

    const $descEdit    = $descContainer.find('.edit-container')
    const $titleEdit   = $titleContainer.find('.edit-container')

    $descEdit.get(0).oldData    = _oldDesc
    $titleEdit.get(0).oldData   = _oldTitle

    $descEdit.html(_descTpl)
    $titleEdit.html(_titleTpl)

    requestAnimationFrame(() => $titleContainer.find('.outer-header').collapse('hide'))
    requestAnimationFrame(() => $descContainer.find('.form-content').collapse('hide'))

    setTimeout(() => {
        requestAnimationFrame(() => {
            $('.question-container .edit-container-callable').collapse('show')
        })
    }, 375)
})

/* EDIT QUESTION MAXLENGTH CHAR COUNT */
$(document).on('keyup', '.edit-question-title-container input[name="question"]', function(e) {
    const _charCount    = this.getAttribute('maxlength') - this.value.length
    const $container    = $(this).closest('.edit-question-title-container')
    $container.find('.char-count').html(_charCount)
})


$(document).on('show.bs.collapse', '.question-container .edit-container.edit-title-container', function() {
    const $questionInput = $(this).find('input[name="question"]');
    $(this).find('.char-count').html($questionInput.get(0).getAttribute('maxlength') - $questionInput.val().length)
})
$(document).on('shown.bs.collapse', '.question-container .edit-container.edit-title-container', function() {
    $(this).find('input[name="question"]').trigger('focus')
})
$(document).on('hidden.bs.collapse', '.question-container .edit-container', function() {
    requestAnimationFrame(() => $('.form-container.question-container').find('.question-editable').collapse('show'))
})

const cancelQuestionEdit = () => {
    const $parent      = $('.form-container.question-container')
    const $outerHeader = $parent.find('.form-header .outer-header')
    const $outerDesc   = $parent.find('.form-body .form-content')

    requestAnimationFrame(() => $parent.find('.edit-container').collapse('hide'))
}

$(document).on('click', '.edit-question-submit', function(e) {
    e.preventDefault()

    const parent                = document.querySelector('.form-container.question-container')
    const titleEditContainer    = parent.querySelector('.edit-container.edit-title-container')
    const descEditContainer     = parent.querySelector('.edit-container.edit-description-container')
    const submitBtn             = titleEditContainer.querySelector('button.edit-question-submit')

    const titleInput    = titleEditContainer.querySelector('input[name="question"]')
    const descInput     = descEditContainer.querySelector('textarea[name="description"]')
    const data  = {
        question: titleInput.value.trim(),
        description: descInput.value.trim()
    }

    if(data.question == titleEditContainer.oldData && data.description == descEditContainer.oldData) {
        cancelQuestionEdit()
        return;
    }

    submitBtn.setAttribute('disabled', true)

    editQuestion(this, data)
    .then((res) => {
        const { data: { question, description, updated_at } } = res.data;
               
        ajaxSuccess(res);
        submitBtn.removeAttribute('disabled')

        titleInput.value = null
        descInput.value = null
        
        $('.question-container .form-header .inner-header .title').text(question)
        $('.question-container .form-header .inner-header .form-date .updated_at').text(updated_at)
        
        $('.question-container .form-body .form-description .form-content').text(description)

        cancelQuestionEdit()
    })
    .catch((err) => {
        submitBtn.removeAttribute('disabled')
    })
})

const editQuestion = (el, data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: el.dataset.href,
            data: data,
            errorHandler: true
        })
        .then((res) => {
            ajaxSuccess(res);
            resolve(res);
        }, (err) => {
            reject(err);
        })
    })
}
const deleteQuestion = (href, questionId, el) => {
    el && el.setAttribute('disabled', true)
    return new Promise((resolve, reject) => {
        axios({
            method: 'DELETE',
            url: href,
            errorHandler: true
        })
        .then((res) => {
            ajaxSuccess(res);
            resolve(res);
        }, (err) => {
            el && el.removeAttribute('disabled', true)
            reject(err);
        })
    })
}

$(document).on('click', '.modal-question-delete .btn-question-delete', function(e) {
    const { href, questionId } = this.dataset;
    deleteQuestion(href, questionId, this)
    .then(res => {
        const { data: { formUrl } } = res.data;
        $(`#deleteQuestion-${questionId}`).modal('hide')
        formUrl && window.location.replace(formUrl)
    })
})

$(document).on('hidden.bs.collapse', '.collapse.file-item', function () {
    this.remove()
})

/* 
 * FIX FILE DELETE
 * duplicating clicks -  previous removed item remains on other delete?
*/

$(document).on('click', '.btn-delete-file', function(e) {
    e.preventDefault()
    const { href, fileId } = this.dataset
    if(!href || !fileId) return;

    $(this).tooltip('hide')

    $('#deleteFileModal .btn-modal-file-delete').attr('data-href', href)
    $('#deleteFileModal .btn-modal-file-delete').attr('data-file-id', fileId)
    $('#deleteFileModal').modal('show')
})

$('#deleteFileModal')
.on('hidden.bs.modal', function (e) {
    $(this).find('.btn-modal-file-delete').removeAttr('disabled')
    $(this).find('.btn-modal-file-delete').removeAttr('data-href')
    $(this).find('.btn-modal-file-delete').removeAttr('data-file-id')
})

$(document)
.on('click', '#deleteFileModal .btn-modal-file-delete', function(e) {    
    $(this).attr('disabled', true)

    const { href, fileId } = this.dataset
    if(!href || !fileId) return;

    axios({
        method: 'DELETE',
        url: href,
    })
    .then((res) => {
        ajaxSuccess(res);

        $(`.files-container  .uploaded-files .file-list .file-item[data-file-id="${fileId}"]`)
        .collapse('hide')

        $('#deleteFileModal').modal('hide')
    }) 
})

/* DROPZONE FILES UPLOAD */
const $formDropzoneEl = $('form#question-file-upload')
const $dropzoneErrors = $('.files-container .browse-files .dropzone-errors')
const $fileListContainer = $('.files-container .uploaded-files .file-list')
if($formDropzoneEl.length) {
    $formDropzoneEl.dropzone({
        maxFiles : 10,
        maxFilesize : 12,
        parallelUploads: 10,
        addRemoveLinks: true,
        uploadMultiple : true,
        acceptedFiles : $mimes,

        init: function() {
            // const qDropzone = this;
            this.on("addedfile", function(e) {
                while (this.files.length > this.options.maxFiles) {
                    toastr.info('Maximum number of files for upload exceeded. Files that exceeded maximum count were removed')
                    // $dropzoneErrors.append('<p>Maximum number of files for upload exceeded. Files that exceeded maximum count were removed.</p>');
                    this.removeFile(this.files[0])
                }
            });

            this.on("complete", function(e) {
                // $dropzoneErrors.empty()
            });

            this.on("fallback", function(e) {
                $(this).find('.fallback').fadeIn()
            });

            this.on("error", function(e, res, xhr) {
                toastr.info(typeof res == 'string' ? res : 'Unable to upload file!')
            });

            this.on("success", function(e, res) {
                const self = this;
                $(e.previewElement).fadeOut({
                    complete: function() {
                        self.removeFile(e)
                    }
                });

                const _tpl = document.querySelector('template#question-file-item').content.cloneNode(true)
                
                const _file = res.data.find(el => el.name === e.name) || null;
                if(!_file?.id) return window.location.reload()

                const _fileName = _file.name || e.name;
                const _fileSize = bytesToHuman(_file.size)

                _tpl.querySelector('.file-item').dataset.fileId = _file.id
                _tpl.querySelector('.file-item .file-info .file-name').innerHTML = _fileName
                _tpl.querySelector('.file-item .file-info .file-download').href = _file.downloadLink
                _tpl.querySelector('.file-item .file-info .file-name').setAttribute('title', `${_fileName} <small>${_fileSize}</small>`)
                _tpl.querySelector('.file-item .file-info .icon-container i').classList.add(iconMimeType(_file.mime))

                const _btnAction = _tpl.querySelector('.file-item .file-action .btn-delete-file')
                if(_btnAction) {
                    _tpl.querySelector('.file-item .file-action .btn-delete-file').dataset.href = _file.destroyLink
                    _tpl.querySelector('.file-item .file-action .btn-delete-file').dataset.fileId = _file.id
                }

                $fileListContainer.append(_tpl)
                $(`.file-item[data-file-id="${_file.id}"]`).collapse('show')
            });
        }
    })
}



export {
    deleteQuestion
}